import React from "react";
import { motion } from "framer-motion";
import { Code2, Server, Zap, Database } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { personalInfo } from "../data/mock";

const pillars = [
  {
    icon: Server,
    title: "Backend Architecture",
    desc: "Designing services with Spring Boot, layered architecture, and clean separation of concerns.",
    accent: "cyan"
  },
  {
    icon: Zap,
    title: "Async & Scale",
    desc: "Apache Kafka for event-driven workflows that stay responsive under concurrent load.",
    accent: "amber"
  },
  {
    icon: Database,
    title: "Data Integrity",
    desc: "ACID-compliant transactions on MySQL/H2 with Hibernate — no inconsistent states.",
    accent: "emerald"
  },
  {
    icon: Code2,
    title: "Clean REST APIs",
    desc: "Versioned, well-documented endpoints with global exception handling and Postman test suites.",
    accent: "cyan"
  }
];

const accentMap = {
  cyan: "text-cyan-300 bg-cyan-500/10 border-cyan-400/20",
  amber: "text-amber-300 bg-amber-500/10 border-amber-400/20",
  emerald: "text-emerald-300 bg-emerald-500/10 border-emerald-400/20"
};

const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading
          eyebrow="About"
          title="Backend engineer who treats systems like puzzles."
          description={personalInfo.longBio}
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                whileHover={{ y: -4 }}
                className="group relative p-6 rounded-2xl glass hover:border-white/15 transition-all duration-300"
              >
                <div
                  className={`w-11 h-11 rounded-xl border flex items-center justify-center mb-4 ${accentMap[p.accent]}`}
                >
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-display text-lg font-semibold text-white mb-2">
                  {p.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
